import { AxiosResponse } from 'axios';
import { RestServiceConnection } from '../restServiceConnection';

const ENDPOINT = '/commercial-network';

export class NetworkService extends RestServiceConnection {

    listNetworks = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/list',
            data: filters,
        }, true) as AxiosResponse;
        return this;
    }

    getNetworkById = async (commercialNetworkId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/get',
            data: { commercialNetworkId },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }

    toggleNetworkState = async (commercialNetworkId: string, status: boolean) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/toggle',
            data: { commercialNetworkId, active: status },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }

    createNetwork = async (values: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/create',
            data: values,
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }

    editNetwork = async (values: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/edit',
            data: values,
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }

    deleteNetwork = async (commercialNetworkId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/delete',
            data: { commercialNetworkId },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }

    deleteMultiNetworks = async (usersIds: string[]) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/delete-multi',
            data: { usersIds }
        }, true);
        return this;
    }

    getNetworksByUser = async (filters: any) => {
        this.response = await this.makeRequest({
            method: 'GET',
            url: ENDPOINT + '/get-user-commercial-networks',
            data: filters,
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }

    getOrganisingCorporations = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/get-organising-corporations',
            data: filters,
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }

    listCommercialNetworksForSelect = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/list-commercial-networks-for-select',
            data: filters,
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }

    listNetworkSettlements = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/list-network-settlements',
            data: filters,
        }, true) as AxiosResponse;
        return this;
    }

    listNetworkSettlementContracts = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/list-network-settlement-contracts',
            data: filters,
        }, true) as AxiosResponse;
        return this;
    }

    exportNetworkSettlements = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/export-network-settlements',
            data: filters,
            responseType: 'arraybuffer',
        }, true);
        return this;
    }

}
